import React, { useState } from "react";
import useApi from "@action.sustainability/storybook-dashboard/utils/fetching";
import { BasicSpinner } from "@action.sustainability/storybook-dashboard/spinners/basicSpinner";
import Octicon from "react-octicon";
import { postFetch, FormGroup } from "./utils";
import { useModal, Modal } from "../modal";

export const formEventToData = (e) => {
  e.preventDefault();
  const formData = new FormData(e.target);
  const data = Object.fromEntries(formData.entries());
  return data;
};

const inviteCompany = ({ e, companyId, setPending, onSuccess }) => {
  e.preventDefault();
  setPending(true);
  const data = formEventToData(e);
  console.log("inviteCompany", e, data);
  postFetch(`/api/company/${companyId}/invite/`, data).then((data) => {
    console.log("Send company invite succeeded", data);
    onSuccess();
  });
};

const addCompanyRole = ({ e, companyId, onSuccess }) => {
  e.preventDefault();
  const data = formEventToData(e);
  console.log("addCompanyRole", e, data);
  postFetch(`/api/company/${companyId}/authgroup/`, data).then((data) => {
    console.log("Added company role", data);
    onSuccess();
  });
};

function AddCompanyRoleForm({ companyId, setAddRole }) {
  const { trigger } = useApi(`/api/company/${companyId}/authgroup/`);

  const onSuccess = () => {
    trigger();
    setAddRole(false);
  };

  return (
    <form
      className="form"
      onSubmit={(e) => addCompanyRole({ e, companyId, onSuccess })}
    >
      <FormGroup id="name" type="name" placeholder="Role name" />
      <button className="btn btn-sm btn-outline-primary">Add role</button>
    </form>
  );
}

const roleOptions = (roles) =>
  roles.map((role, i) => (
    <option key={i} value={role.get("uid")}>
      {role.get("name")}
    </option>
  ));

function CompanyRoleSelector({ companyId, setAddRole }) {
  const { data, isLoading } = useApi(`/api/company/${companyId}/authgroup/`);

  if (isLoading) {
    return <BasicSpinner />;
  }

  return (
    <div className="form-group" style={{ display: "none" }}>
      <label>
        Role (
        <span
          className="btn btn-sm btn-link"
          style={{ cursor: "pointer" }}
          onClick={() => setAddRole(true)}
        >
          add new
        </span>
        )
      </label>
      <select name="auth" className="form-control">
        {roleOptions(data)}
      </select>
    </div>
  );
}

export function CompanyInviteForm({ companyId }) {
  const { data, isLoading } = useApi(`/api/company/${companyId}/authgroup/`);
  const { hideModal } = useModal();
  const [pending, setPending] = useState(false);
  const [addRole, setAddRole] = useState();

  const onSuccess = () => {
    hideModal();
    window.location.reload();
  };

  if (isLoading) {
    return <BasicSpinner />;
  }

  if (addRole) {
    return <AddCompanyRoleForm {...{ companyId, setAddRole }} />;
  }

  return (
    <form
      className="form"
      onSubmit={(e) => inviteCompany({ e, companyId, setPending, onSuccess })}
    >
      <FormGroup id="email" type="email" placeholder="Email address" />
      <CompanyRoleSelector {...{ companyId, setAddRole }} />
      <button className="btn btn-sm btn-outline-primary" disabled={pending}>
        Send invitation
      </button>
    </form>
  );
}

export function CompanyInviteModal({ companyId }) {
  return (
    <Modal title="Invite user">
      <CompanyInviteForm companyId={companyId} />
    </Modal>
  );
}

export function CompanyInviteButton({ companyId }) {
  useApi(`/api/company/${companyId}/authgroup/`);
  const { setModal } = useModal();

  return (
    <>
      <button
        className="btn btn-sm btn-primary float-right mb-3"
        onClick={() => setModal(<CompanyInviteModal companyId={companyId} />)}
      >
        Add new user <Octicon className="ml-2 pt-1" name="plus" />
      </button>
      <div style={{ clear: "both" }} />
    </>
  );
}
